import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Label from '@xingternal/malt-label';
import testable from '@xingternal/malt-util/testable';
import { QA_MALT } from '@xingternal/malt-constants';

import styles from './FormField.css';

const TestableDiv = testable(QA_MALT, 'div');

const ERROR_MESSAGE_TEST_ID_APPENDIX = '-error-message';
const HINT_MESSAGE_TEST_ID_APPENDIX = '-hint-message';

const FormField = ({
  className,
  children,
  label,
  errorMessage,
  hintMessage,
  testId,
}) => (
  <TestableDiv
    className={classnames(styles.formField, className)}
    testId={testId}
  >
    {label ? <Label>{label}</Label> : null}
    {children}
    {errorMessage ? (
      <TestableDiv
        className={styles.errorMessage}
        testId={testId && `${testId}${ERROR_MESSAGE_TEST_ID_APPENDIX}`}
      >
        {errorMessage}
      </TestableDiv>
    ) : hintMessage ? (
      <TestableDiv
        className={styles.hintMessage}
        testId={testId && `${testId}${HINT_MESSAGE_TEST_ID_APPENDIX}`}
      >
        {hintMessage}
      </TestableDiv>
    ) : null}
  </TestableDiv>
);

FormField.displayName = 'FormField';

FormField.propTypes = {
  /** Contents of FormField */
  children: PropTypes.node.isRequired,
  /** add a custom className */
  className: PropTypes.string,
  /** provide an error message for the input. Is this used the text input will automatically turn invalid. */
  errorMessage: PropTypes.node,
  /** provide a hint message for the input. Overridden if errorMessage is present. */
  hintMessage: PropTypes.node,
  /** renders a label above the text input */
  label: PropTypes.node,
  /** define a testid for the text input */
  testId: PropTypes.string,
};

export default FormField;
